module.exports = __webpack_public_path__ + "static/img/map-bg - 副本.cb4f1c3b.jpg";